<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-menu-button></ion-menu-button>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>User Creation</ion-title>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="hdrBtn" @click="addNewCPO">
            <ion-icon v-slot: start :icon="add" ></ion-icon>&nbsp;Add Users
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <CPOUserCreation />
    </ion-content>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { add } from 'ionicons/icons';
import CPOUserCreation from "@/components/admin/CPOUserCreation.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar, IonBackButton } from '@ionic/vue';

export default defineComponent({
  name:  'tariffCreation',
  components: {
    CPOUserCreation, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent, IonBackButton
  },
  data() {
    return {
      add
    }
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    },

    addNewCPO() {
      localStorage.removeItem("isEditingUser");
      localStorage.removeItem("editUserData");
      this.$router.push("addNewUser"); 
    }
  }
})
</script>